const data = {
	"width": 1664,
	"height": 1312,
	"body": "<path fill=\"currentColor\" d=\"m1619 552l-742 741q-19 19-45 19t-45-19L45 552q-19-19-19-45.5T45 461l166-165q19-19 45-19t45 19l531 531l531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z\"/>"
};
export default data;
